/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { calculateDiscountComboModifierRequestSchema } from "./calculateDiscountComboModifierRequestSchema.ts";

export const comboCalculationModifierRequestSchema = calculateDiscountComboModifierRequestSchema;
